var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{staticClass:"d-flex",attrs:{"datetime":_vm.time}},[_vm._v("\n    "+_vm._s(_vm.formatted)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }